module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTYnIGhlaWdodD0nMTYnIHZpZXdCb3g9JzAgMCAxNiAxNicgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNMTYgMWMwLS41NDctLjQ1My0xLTEtMUgxQy40NTMgMCAwIC40NTMgMCAxdjE0YzAgLjU0Ny40NTMgMSAxIDFoNy41NTVWOS43ODFoLTJWNy40NzdoMlY1LjQ4NGMwLTEuODIgMS4xMS0zLjAzOSAzLjMwNC0zLjAzOS45NyAwIDEuNjQxLjExIDEuNjQxLjExdjIuMDc4SDEyYy0uNjY0IDAtMSAuMzc1LTEgMS4wMzF2MS44MTNoMi4zMzZMMTMgOS43OGgtMlYxNmg0Yy41NDcgMCAxLS40NTMgMS0xVjF6JyBmaWxsPScjRkZGJyBmaWxsLXJ1bGU9J2V2ZW5vZGQnLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/facebook.svg
// module id = 246
// module chunks = 114276838955818 184470312924441